<div class="twofactor-wrapper">
  <div class="column__figure">
    <h2>
      Multi-Factor <br />
      Authentication
    </h2>
    <div class="figure__icon"><img src="assets/styles/portal/build/assets/images/multifactor.svg" alt="Manage Your Account" /></div>
    <p>Manage Your Account</p>
  </div>
  <div class="column__content">
    <img src="assets/styles/portal/build/assets/images/reflecx-logo.svg" class="tf-logo" alt="Reflecx" />
    <h3>Manage your account</h3>
    <h1>Recovery code verification</h1>
    <div *ngIf="!isVerified">
      <p>
        You have requested to login with a recovery code. Please enter recovery code to login, 
        you will be required to reconfigure two factor via authenticator app via next login
        </p>
        

        <form [formGroup]="recoveryForm" (ngSubmit)="onLogin()">
          <div class="tf-form-field">
            <div class="tf-label"><label>ENTER USER ID</label></div>
            <div class="tf-field"><input class="tf-input" type="text" formControlName="userName" /></div>
            <div *ngIf="userName.invalid && (userName.dirty || userName.touched)" class="alert">
              <div *ngIf="userName.errors?.['required']">
                USER ID is required.
              </div>
            </div>

          </div>
          <div class="tf-form-field">
            <div class="tf-label"><label>Recovery Code</label></div>
            <div class="tf-field"><input class="tf-input" type="text" formControlName="code"  /></div>
            <div *ngIf="code.invalid && (code.dirty || code.touched)" class="alert">
              <div *ngIf="code.errors?.['required']">
                Code is required.
              </div>
            </div>
          </div>

          <div class="tf-form-field">
            <button type="submit" class="tf-error-btn" [disabled]="!recoveryForm.valid">Unlock</button>
          </div>
        </form>

    </div>

    <div *ngIf="isVerified">
      <p>
        Your account has been recovered successfully. On your next login you will be prompted to reconfigure two factor authentication on your device
      </p>
    </div>

    <div class="tf-form-field">
      <button type="button" class="tf-black-error-btn" (click)="onBack()">Back to Home</button>
    </div>
  </div>
</div>
